import React from 'react'
import Slider from "react-slick";

export default function GoaNearby() {
    const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 1100,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: false,
    cssEase: "ease",
    responsive: [
        {
        breakpoint: 767,
        settings: { slidesToShow: 2,},
        },
        {
        breakpoint: 599,
        settings: { slidesToShow: 1,},
        },
    ],
    };

  return (
    <>
    <section className="goa-nearby">
        <div className="big-container">
            <div className="row">
                
                <div className="col-lg-12">
                    <h4 className='heading center-heading'>Nearby Attractions</h4>

                    <Slider {...settings} className="goanearby-slider">
                        <div className="goanearby-box">
                            <img src="/image/goa-attaraction-1.webp" loading="lazy" className="img-responsive" alt="attaraction"/>
                             <div className='goanearby-distance'>
                                <img src='/image/nearby-icon-1.webp' alt="icon" />
                                <label>3.5 km</label>
                            </div>
                            <span>Baga Beach</span>
                            <p>Baga Beach offers lively beach shacks, exciting water sports, and vibrant nightlife along Goa’s most energetic shoreline.</p>
                        </div>
                
                        <div className="goanearby-box">
                            <img src="/image/goa-attaraction-2.webp" loading="lazy" className="img-responsive" alt="attaraction"/>
                             <div className='goanearby-distance'>
                                <img src='/image/nearby-icon-1.webp' alt="icon" />
                                <label>2.1 km</label>
                            </div>
                            <span>dudhsagar waterfall</span>
                            <p>One of India’s tallest waterfalls, known for its breathtaking milky-white cascade flowing through lush green forests.</p>
                        </div>

                        <div className="goanearby-box">
                            <img src="/image/goa-attaraction-3.webp" loading="lazy" className="img-responsive" alt="attaraction"/>
                             <div className='goanearby-distance'>
                                <img src='/image/nearby-icon-1.webp' alt="icon" />
                                <label>6.8 km</label>
                            </div>
                            <span>Fort Aguada</span>
                            <p>Fort Aguada is a historic Portuguese fort offering panoramic sea views, scenic sunsets, and a glimpse into Goa’s colonial heritage.</p>
                        </div>

                        <div className="goanearby-box">
                            <img src="/image/goa-attaraction-4.webp" loading="lazy" className="img-responsive" alt="attaraction"/>
                             <div className='goanearby-distance'>
                                <img src='/image/nearby-icon-1.webp' alt="icon" />
                                <label>9.9 km</label>
                            </div>
                            <span>Chapora Fort</span>
                            <p>A scenic hilltop fort offering stunning panoramic views of the Arabian Sea, ideal for sunset experiences and photography.</p>
                        </div>

                         <div className="goanearby-box">
                            <img src="/image/goa-attaraction-5.webp" loading="lazy" className="img-responsive" alt="attaraction"/>
                             <div className='goanearby-distance'>
                                <img src='/image/nearby-icon-1.webp' alt="icon" />
                                <label>2.3 km</label>
                            </div>
                            <span>Candolim beach</span>
                            <p>Golden shores, vibrant beach shacks, exciting water sports, and a relaxing coastal atmosphere make this destination truly unforgettable</p>
                        </div>
                    </Slider>
                </div>

            </div>
        </div>
    </section>            
    </>
  )
}
